import {
  ChangeEmailAddressPayload,
  DeleteAccountPayload,
  ChangeEmailStartPayload,
  ChangeEmailVerifyPayload,
  I18nAccountError,
  Mutation as accountMutations,
} from './account/account-resolver-overrides';
import {
  UnsubscribeApacSavedSearchByCodePayload,
  UpdateNotificationCtpPreferencesPayload,
  UpdateNotificationCtpSubscriptionWithTokenPayload,
  Mutation as notificationsMutations,
  Candidate as notificationCandidates,
} from './notifications/notifications-resolver-overrides';
import {
  Query as visibilityQueries,
  Candidate as visibilityCandidates,
  Mutation as visibilityMutations,
  ProfileVisibilityOption,
  UpdateProfileVisibility2Payload,
} from './visibility/visibility-resolver-overrides';

const resolverOverrides = (_mockStore: any) => ({
  // Account:
  ChangeEmailAddressPayload,
  I18nAccountError,
  DeleteAccountPayload,
  ChangeEmailStartPayload,
  ChangeEmailVerifyPayload,

  // Visibility:
  ProfileVisibilityOption,
  UpdateProfileVisibility2Payload,

  // Notifications:
  UnsubscribeApacSavedSearchByCodePayload,
  UpdateNotificationCtpPreferencesPayload,
  UpdateNotificationCtpSubscriptionWithTokenPayload,

  Query: {
    ...visibilityQueries,
  },

  Mutation: {
    ...accountMutations,
    ...visibilityMutations,
    ...notificationsMutations,
  },

  Candidate: {
    _id: () => '34712547',
    id: () => 34712547,
    ...notificationCandidates,
    ...visibilityCandidates,
  },
});

export default resolverOverrides;
